<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Cotizaciones a Clientes</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12">
              <div class="form-inline">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="# Pedido"
                  v-model="search.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                  style="width: 90px"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Nit cliente"
                  v-model="search.cliente"
                  type="text"
                  v-on:keyup.enter="filterData()"
                  style="width: 100px"
                />
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tienda"
                  @change="refreshCajas()"
                  style="width: 100px"
                >
                  <option value="">Tiendas</option>
                  <option
                    v-for="data in tiendas"
                    :value="data.codigo"
                    v-bind:key="data.id"
                  >
                    {{ data.nombre }}
                  </option>
                </select>
                <input
                  type="date"
                  v-model="search.fecha"
                  style="width: 130px"
                  class="form-control form-control-sm rounded bright"
                />
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_caja"
                  @change="filterData()"
                  style="width: 100px"
                >
                  <option value="">cajas</option>
                  <option
                    v-for="data in cajas"
                    :value="data.id"
                    v-bind:key="data.id"
                  >
                    {{ data.caja }}
                  </option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData()"
                  style="width: 108px"
                >
                  <option value>Estatus</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="E">IMPRESA</option>
                </select>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                  style="width: 120px"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData()"
                    style="width: 60px"
                  >
                    <i class="fa fa-search"></i>
                    Buscar
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                    style="width: 30px"
                  >
                    <i class="fa fa-times"></i>
                    Limpiar
                  </button>
                </div>
              </div>
              <br />
              <NuevaCotizacionModalComponent />
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Tienda</th>
                <th>Vendedor</th>
                <th>Cliente</th>
                <th>Estado</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.numero }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>
                  <UsuarioEnTablaComponent :current="current.vendedor" />
                </td>
                <td v-if="current.cliente_nit">
                  ({{ current.cliente_nit }}) {{ current.cliente_nombre }}
                </td>
                <td class="text-right">
                  <div
                    data-title="Activo"
                    data-toggle="tooltip"
                    v-html="current.estado_str"
                  ></div>
                </td>
                <td class="text-right">Q {{ current.total }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import NuevaCotizacionModalComponent from "@/components/pos/cotizaciones/NuevaCotizacionModalComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    NuevaCotizacionModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      data: [],
      search: {},
      filtro_tienda: "",
      tiendas: "",
      filtro_estado: "",
      filtro_caja: "",
      cajas: "",
    };
  },
  mounted() {
    this.refreshData();
    this.refreshTienda();
  },
  methods: {
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    refreshCajas() {
      let self = this;
      DynamicService.fetch("cxc", "caja", {
        tienda: self.filtro_tienda,
        quitar_paginacion: true,
      }).then((response) => {
        self.cajas = response.data;
      });
    },
    refreshTienda() {
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        this.tiendas = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "pos-cotizaciones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "pos-cotizaciones-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.currentPage = page;
      this.refreshData({
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        caja: this.filtro_caja,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha,
        solo_cot: true,
      });
    },
    filterData() {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.refreshData({
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        caja: this.filtro_caja,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha,
        solo_cot: true,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.filtro_caja = "";
      this.searchtext = "";
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
        solo_cot: true,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      if (!params) {
        params = {
          solo_cot: true,
        };
      }
      DynamicService.fetch("cxc", "pedidos", params).then((response) => {
        self.data = response.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
